import { numeralFormatterCurrency, formatDecimalAsPercentage } from 'ns_libs/formatter';
import { Attributes, dollarValueAttributes, percentageValueAttributes } from '../constants';

export const getFormattedFilterValue = (filterAttribute: Attributes, filterValue?: string): string => {
    if (dollarValueAttributes.includes(filterAttribute)) {
        if (filterAttribute === Attributes.AcquisitionPrice) {
            return numeralFormatterCurrency(filterValue, '$0,0');
        }
        return numeralFormatterCurrency(filterValue);
    }
    if (percentageValueAttributes.includes(filterAttribute)) {
        return filterValue ? formatDecimalAsPercentage(Number(filterValue), 2) : '';
    }
    return filterValue || '';
};

export const getFormattedRangeValue = (filterAttribute: Attributes, filterRange: { from?: string; to?: string }): string => {
    const fromValue = getFormattedFilterValue(filterAttribute, filterRange.from);
    const toValue = getFormattedFilterValue(filterAttribute, filterRange.to);

    return `${fromValue} - ${toValue}`;
};
